<template>
  <div>
    <!-- <div class="footer">copyright © 鲁ICP备2021028667号 版权所有：济南台菱自动化科技有限公司 rights reserved.</div> -->
    <div class="footer">copyright © 版权所有：华控（山东）技术有限公司 rights reserved.</div>
    <div class="footer2">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener"
        style="color: #ccc; text-decoration: none;">鲁ICP备2024086658号-2</a>
      <img src="/static/a.png" alt="备案图标" style="vertical-align: middle; margin: 0 10px; height: 20px; width: auto;" />
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37011202002557" target="_blank"
        rel="noopener" style="color: #ccc; text-decoration: none;">鲁公网安备37011202002557号</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ValidCode',
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.footer {
  width: 100%;
  padding-top: 30px;
  background: #333333;
  text-align: center;
  line-height: 24px;
  font-size: 18px;
  font-family: ArialMT;
  color: #FFFFFF;
}

.footer2 {
  width: 100%;
  height: 80px;
  background: #333333;
  text-align: center;
  line-height: 80px;
  font-size: 18px;
  font-family: ArialMT;
  color: #FFFFFF;
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue